import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AdminUser, AdminUsersResponse, UserBusqueda, UserFilter } from '../models/userlist.model';

// POST con los filtros en el body (no en la URL) para que el DNI y el email
// no queden en logs ni en el historial del navegador.
@Injectable({ providedIn: 'root' })
export class UserListApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrls.accountService;

  getUsers(filter: UserFilter, page: number, size: number, busqueda: UserBusqueda = {}): Observable<AdminUsersResponse> {
    return this.http.post<AdminUsersResponse>(`${this.apiUrl}/users`, {
      filter, page, size,
      dni: busqueda.dni || undefined,
      email: busqueda.email || undefined
    });
  }

  exportUsers(filter: UserFilter, busqueda: UserBusqueda = {}): Observable<AdminUser[]> {
    return this.http.post<AdminUser[]>(`${this.apiUrl}/users/export`, {
      filter,
      dni: busqueda.dni || undefined,
      email: busqueda.email || undefined
    });
  }
}
